// extracted by mini-css-extract-plugin
module.exports = {"note":"Note_note__yQ40k","content":"Note_content__x0MdW","iconWrapper":"Note_iconWrapper__VAuIJ","text":"Note_text__j4_X6"};